export default __webpack_public_path__ + "static/media/hoppia_vtuber_logo.246d94bf.svg";